import DefaultView from 'nette-base-module/js/views/default'
import merge from 'lodash/merge'

export default merge(
  {
    props: [
      'contract', // shit :( from contractable menu -> moduleActions has no snippet div in ajax modules, cant define from snippet definition
    ],
    inject: {
      ...DefaultView.inject,
      adminModulePanelId: {
        name: 'adminModulePanelId',
        default: null,
      },
      isInRoot: {
        name: 'isInRoot',
      },
    },
  },
  DefaultView
)
